export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10348.77d16a94.jpg";